module.exports = __webpack_public_path__ + "static/media/bg-1.79d89334.jpg";